import { render, staticRenderFns } from "./IncreaseChartContent.vue?vue&type=template&id=2a99709e"
import script from "./IncreaseChartContent.vue?vue&type=script&lang=js"
export * from "./IncreaseChartContent.vue?vue&type=script&lang=js"
import style0 from "./IncreaseChartContent.vue?vue&type=style&index=0&id=2a99709e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports